import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSettings } from '../context/SettingsContext';

/**
 * PlanSelect
 * Props:
 *   value      – current planId (ObjectId string) or '' for none
 *   onChange   – (planId, planName, planPrice) => void
 *   disabled   – bool
 *   style      – extra style for the select element
 *   showPrice  – bool (default true)
 */
export default function PlanSelect({ value, onChange, disabled, style, showPrice = true }) {
  const { t }  = useSettings();
  const [plans,   setPlans]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/plans')
      .then(res => setPlans(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    const planId = e.target.value;
    const plan   = plans.find(p => String(p._id) === planId);
    onChange(planId, plan ? plan.name : null, plan ? plan.price : null);
  };

  return (
    <select
      value={value || ''}
      onChange={handleChange}
      disabled={disabled || loading}
      style={style}
    >
      <option value="">{t('noPlanSelected')}</option>
      {plans.map(p => (
        <option key={p._id} value={String(p._id)}>
          {p.name}{showPrice ? ` — ${p.price.toLocaleString()} UZS` : ''}
        </option>
      ))}
    </select>
  );
}
